import { render, staticRenderFns } from "./NsProductSkuPoints.vue?vue&type=template&id=230a8414&scoped=true&"
import script from "./NsProductSkuPoints.vue?vue&type=script&lang=js&"
export * from "./NsProductSkuPoints.vue?vue&type=script&lang=js&"
import style0 from "./NsProductSkuPoints.vue?vue&type=style&index=0&id=230a8414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a8414",
  null
  
)

export default component.exports